import { render } from "./TopicHeader.vue?vue&type=template&id=7e58ddaf&scoped=true"
import script from "./TopicHeader.vue?vue&type=script&lang=js"
export * from "./TopicHeader.vue?vue&type=script&lang=js"

import "./TopicHeader.vue?vue&type=style&index=0&id=7e58ddaf&lang=sass&scoped=true"

import exportComponent from "/Users/priscillacancar/Documents/Coding/1) Engram-site/Engram/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e58ddaf"]])

export default __exports__